import { lazy } from "react"
import {
  EMAIL_VERIFICATION_SCREEN,
  LOGIN_SCREEN,
  LOST_PASSWORD_SCREEN,
  ONBOARDING_SCREEN,
  PASSWORD_RESET_CONFIRM_SCREEN,
  REQUEST_ACCESS_SCREEN,
  RESET_PASSWORD_VIEW,
  SIGNUP_SCREEN,
} from "./route-list"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const NotFoundPage = lazy(
  () => import("@/features/home/views/not-found-page/not-found-page"),
)
const EmailVerification = lazy(
  () =>
    import(
      "@/features/register-login/views/email-verification/email-verification"
    ),
)
const LoginView = lazy(
  () => import("@/features/register-login/views/login-view/login-view"),
)
const LostPassword = lazy(
  () => import("@/features/register-login/views/login-view/lost-password"),
)
const OnboardingView = lazy(
  () => import("@/features/register-login/views/onboarding/onboarding-view"),
)
const SignupView = lazy(
  () => import("@/features/register-login/views/signup-view/signup-view"),
)
const RequestAccessView = lazy(
  () =>
    import(
      "@/features/register-login/views/request-access-view/request-access-view"
    ),
)
const PasswordResetConfirm = lazy(
  () =>
    import(
      "@/features/settings-account/views/password-reset-confirm/password-reset-confirm"
    ),
)
const SettingsResetPassword = lazy(
  () =>
    import(
      "@/features/settings-account/views/settings-reset-password/settings-reset-password"
    ),
)
export const unauthenticatedRoutes = [
  {
    path: RESET_PASSWORD_VIEW,
    element: <SettingsResetPassword />,
  },
  { path: LOGIN_SCREEN, element: <LoginView /> },
  { path: LOST_PASSWORD_SCREEN, element: <LostPassword /> },
  { path: SIGNUP_SCREEN, element: <SignupView /> },
  { path: REQUEST_ACCESS_SCREEN, element: <RequestAccessView /> },
  { path: PASSWORD_RESET_CONFIRM_SCREEN, element: <PasswordResetConfirm /> },
  { path: EMAIL_VERIFICATION_SCREEN, element: <EmailVerification /> },
  {
    path: ONBOARDING_SCREEN,
    element: <OnboardingView />,
  },
  { path: "*", element: <NotFoundPage /> },
]

export const UNAUTHENTICATED_ROUTES = {
  element: <NoMenuLayout />,
  children: unauthenticatedRoutes,
}
